import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseTrancheApi } from "./types";
import { PaymentPolicyFormValues } from "pages/CourseCreate/PaymentPolicy/PaymentPolicyForm";

const create = (courseId: number, data: CreateCourseTrancheApiRequest): AxiosPromise => {
  return api.post(endpoints.COURSESTRANCHES.CREATE(courseId), data);
};
const update = (courseId: number, trancheId: number, data: CreateCourseTrancheApiRequest): AxiosPromise => {
  return api.put(endpoints.COURSESTRANCHES.UPDATE(courseId, trancheId), data);
};
const fetchByCourseId = (courseId: number) => {
  return api.get<CourseTranchesResponse>(endpoints.COURSESTRANCHES.GET(courseId));
};
const fetchCoursePolicies = (courseId: number): AxiosPromise<CoursePricesResponse> => {
  return api.get<CoursePricesResponse>(endpoints.COURSESTRANCHES.GET_POLICIES(courseId));
};
const deletePolicy = (courseId: number, policyId: number): AxiosPromise => {
  return api.delete(endpoints.COURSESTRANCHES.DELETE_POLICY(courseId, policyId));
};
const deleteTranche = (courseId: number, trancheId: number): AxiosPromise => {
  return api.delete(endpoints.COURSESTRANCHES.DELETE(courseId, trancheId));
};
const createTranchePolicy = (courseId: number, data: PaymentPolicyFormValues): AxiosPromise<number> => {
  return api.post(endpoints.COURSESTRANCHES.CREATE_POLICY(courseId), data);
};

const generatePaymentLink = (
  courseId: number,
  data: GeneratePaymentLinkRequest,
): AxiosPromise<GeneratePaymentLinkResponse> => {
  return api.post(endpoints.COURSESTRANCHES.GENERATE_PAYMENT_LINK(courseId), data);
};

export const coursetranchesApi = {
  create,
  update,
  fetchByCourseId,
  delete: deleteTranche,
  deletePolicy,
  fetchCoursePolicies,
  createTranchePolicy,
  generatePaymentLink,
};

export interface PriceAdjustmentRange {
  startDate: Date;
  endDate: Date;
  adjustedPrice: {
    price: number;
    tranches: {
      name: string;
      courseTrancheId: number;
      price: number;
      dueDate: Date | null;
    }[];
  };
}
export interface CoursePricesResponse {
  ranges: PriceAdjustmentRange[];
  standardPrice: number;
  lowestPrice: number;
  highestPrice: number;
  policies: CourseTranchePriceApi[];
}
export interface CourseTranchePriceApi {
  amount: number;
  createdDate: Date;
  from: Date;
  id: number;
  repeat: number;
  to?: Date;
  tranche: CourseTrancheApi;
  type: number;
}
export interface CourseTranchesResponse {
  data: CourseTrancheApi[];
  isReady: boolean;
}

export interface CreateCourseTrancheApiRequest {
  name: string;
  price: number;
  dueDate: Date | null;
  isRequired: boolean;
  description?: string;
}

export interface GeneratePaymentLinkRequest {
  userId: number;
  amountToPay: number;
  selectedTranchesIds: number[];
}

export interface GeneratePaymentLinkResponse {
  paymentLink: string;
  paymentId: number;
}
